/**
 * Handle redirect to stores
 *
 * @param container {HTMLElement} container element
 */

export default (container: HTMLElement) => {
  const stores = [...container.getElementsByClassName("js-appStoreItem")];
  let url;

  // Generate url for Adroid
  function generateGooglePlayReferrerURL(packageName, data) {
    if (!data || Object.keys(data).length === 0) {
      return `https://play.google.com/store/apps/details?id=${packageName}`;
    }
    const encoder = new TextEncoder();
    const dataUint8Array = encoder.encode(JSON.stringify(data));
    const base64Text = btoa(String.fromCharCode.apply(null, dataUint8Array));
    const ndbRefererString = encodeURIComponent(`ndb_referrer=${encodeURIComponent(base64Text)}`);
    return `https://play.google.com/store/apps/details?id=${packageName}&referrer=${ndbRefererString}`;
  }

  stores.forEach((element: HTMLElement) => {
    element.addEventListener("click", (event) => {
      const typ = element.dataset.storetype;
      const config = element.dataset.storeconfigjson;
      const googleConfig = {
        businessContextProductId: `${element.dataset.storeconfigbusinesscontextproductid}`,
        businessContextProductGroup: `${element.dataset.storeconfigbusinesscontextproductgroup}`,
        phone: `${element.dataset.storeconfigphonecode}`,
        caseId: `${element.dataset.storeconfigcaseidcode}`,
        kbCzSessionId: `${element.dataset.storekbczsessionid}`,
      };

      if (typ === "apple") {
        event.preventDefault();
        navigator.clipboard.writeText(config);
        window.location.href = element.querySelector("a").href;
      } else if (typ === "google") {
        event.preventDefault();
        const packageName = element.dataset.storepackage;
        url = generateGooglePlayReferrerURL(packageName, googleConfig);
        window.location.href = url;
      }
    });
  });
};
